// extracted by mini-css-extract-plugin
export var gc = "styles-module__gc___yOONx";